const func = (jQuerytarget) => {

  $(document).ready(function () {
    let contentSlider,imageSlider;
    $('.sticky-img-scroll').removeClass('d-none');

    function sliderController(fade = true) {

      if (contentSlider) contentSlider.destroy(true, true);
      if (imageSlider) imageSlider.destroy(true, true);

      let sliderOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        direction: "vertical",
        mousewheel: {
          releaseOnEdges: true,
        },
      }

      let contentSliderOptions = Object.assign({}, sliderOptions, {
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".sticky-scroll-swiper-button-prev",
          prevEl: ".sticky-scroll-swiper-button-next",
        },
      });

      let imageSliderOptions = Object.assign({}, sliderOptions, fade ? {
        effect: "fade",
      } : {});
      
      contentSlider = new Swiper($(".sticky-scroll-content-slider-init"), contentSliderOptions);
      imageSlider = new Swiper($(".sticky-scroll-image-slider-init"), imageSliderOptions);

      if(fade){
        imageSlider.controller.control = contentSlider;
        contentSlider.controller.control = imageSlider;
      }

      imageSlider.on('transitionEnd', function () {
        $('.sticky-img-scroll').attr('data-kd-theme' , $('.swiper-slide-active').attr('data-kd-theme'));
      });
    }

    function handlePadding() {
      const windowWidth = $(window).width();
      let padding = 0;

      if (windowWidth >= 1200) {
          padding = (windowWidth - 1140) / 2;
      } else if (windowWidth >= 992) {
          padding = (windowWidth - 960) / 2;
      } else if (windowWidth >= 768) {
          padding = (windowWidth - 720) / 2;
      } else if (windowWidth >= 576) {
          padding = (windowWidth - 540) / 2;
      }

      const paddingValue = `${padding + 15}px`;
      if(windowWidth > 998){
        $('.sticky-scroll-content-slider-init').css('padding-left', paddingValue);
        $('.sticky-scroll-swiper-button-next , .sticky-scroll-swiper-button-prev').css('right', `${padding-22}px`);
        $('.sticky-scroll-image-slider-init').css('padding-right', paddingValue);
      }else{
        $('.sticky-scroll-content-slider-init').css('padding', `0 ${paddingValue}`);
        $('.sticky-scroll-image-slider-init').css('padding',`0 ${paddingValue}`);
      }
    }

    function initializeSliders() {
      if ($(window).width() <= 998) {
        if (contentSlider) contentSlider.destroy(true, true);
        if (imageSlider) imageSlider.destroy(true, true);
        $('.sticky-img-scroll').attr('data-kd-theme' , 'light');
      } else {
        sliderController();
      }
      handlePadding();
    }

    window.loader.key("swiper", function () {
      initializeSliders();
      $('.sticky-img-scroll').attr('data-kd-theme' , $('.swiper-slide-active').attr('data-kd-theme'));
      $(window).resize(function () {
        $('.sticky-img-scroll').attr('data-kd-theme' , $('.swiper-slide-active').attr('data-kd-theme'));
        initializeSliders();
      });
    });
  })
};

export default func;
